import conn from "@/store/utils/connection";
import api from "./../apiEndPoint";
import resulter from "@/store/utils/resulter";

export default {
	fetchListHistory({commit, getters}, payload = {}) {
		let query = {
			offset: getters.pagination.offset,
			limit: getters.pagination.limit,
		}
		if (payload.key) query.key = payload.key
		if (payload.iddevice) query.iddevice = payload.iddevice
		commit("setFetching", true);
		commit("resetListHistoryTemp")
		conn.get(api.listHistory, query)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					conn.setQueryString(query);
					commit("setListHistory", data);
					commit("setListHistoryTemp", data)
					commit("setEndItemofPage", data.array[data.array.length - 1]);
					commit("setNextPagination", data.array);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setSearchLoading", false)
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchCountTemplate({commit, getters}) {
		commit("setFetching", true);
		conn.get(api.countTemplate)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					commit("setCountTemplate", data);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchWaDevice: ({commit, dispatch}, payload = null) => {
		let query = {
			offset: 0,
			limit: 500,
		};
		if (payload !== null) {
			if (payload.status) query.status = payload.status
		}
		commit("setFetching", true);
		commit("setResponse", {});
		conn.get(api.listDeviceTiny, query)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					commit("setWaDevice", data.array);
					commit("setFetching", false);
				} else {
					commit("setResponse", resulter.errorResult(msg));
					commit("setFetching", false);
				}
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchDetailHistory({commit}, id) {
		commit("setFetching", true);
		conn.get(api.detailHistory + "/" + id)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					commit("setDetailHistory", data);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
			})
			.catch((e) => {
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchListMessage({commit, getters}, payload = {}) {
		let query = {
			offset: getters.paginationMessage.offset,
			limit: getters.paginationMessage.limit,
		}
		if (payload.key) query.key = payload.key
		if (payload.status) query.status = payload.status
		commit("setFetching", true);
		conn.get(api.listMessageInDetailHistory + "/" + payload.id, query)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					conn.setQueryString(query);
					commit("setListMessage", data);
					commit("setNextPaginationMessage", data.array);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
				commit("setLoadMore", false);
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchDetailTemplate({commit}, id) {
		commit("setFetching", true);
		conn.get(api.detailTemplate + "/" + id)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					commit("setDetailTemplate", data);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
			})
			.catch((e) => {
				commit("setResponse", resulter.errorResult(e));
			});
	},
	fetchListTemplate({commit, getters}, payload = {}) {
		let query = {
			offset: getters.paginationTemplate.offset,
			limit: getters.paginationTemplate.limit,
			jenis: getters.paginationTemplate.jenis,
		}
		if (payload.key) query.key = payload.key
		if (payload.jenis) query.jenis = payload.jenis
		commit("setFetching", true);
		conn.get(api.listTemplate, query)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					conn.setQueryString(query);
					commit("setListTemplate", data);
					commit("setEndItemofPage", data.array[data.array.length - 1]);
					commit("setNextPaginationTemplate", data.array);
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setSearchLoading", false)
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},
	deleteTemplate: ({commit}, id) => {
		commit("setFetching", true);
		return conn.post(api.deleteTemplate + "/" + id, null, conn.contentType.form);
	},
	createBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.createBlast, payload, conn.contentType.json);
	},
	fetchListCustomer({commit, getters, rootGetters}, payload = {}) {
		let payloadCreateBlast = getters.payloadCreateBlast
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];
		let query = {}
		if (getFilterItem.filterRentangTanggalKonsumen) {query.filter_kolom = getFilterItem.filterRentangTanggalKonsumen}
		if (payload.key) {query.key = payload.key; payloadCreateBlast.filter_customer.key = payload.key}
		if (payload.filter_by) {query.filter_by = payload.filter_by; payloadCreateBlast.filter_customer.filter_by = payload.filter_by}
		if (payload.tahun) {query.tahun = payload.tahun; payloadCreateBlast.filter_customer.tahun = payload.tahun}
		if (payload.bulan) {query.bulan = payload.bulan; payloadCreateBlast.filter_customer.bulan = payload.bulan}
		if (payload.tanggal_awal) {query.tanggal_awal = payload.tanggal_awal; payloadCreateBlast.filter_customer.tanggal_awal = payload.tanggal_awal}
		if (payload.tanggal_akhir) {query.tanggal_akhir = payload.tanggal_akhir; payloadCreateBlast.filter_customer.tanggal_akhir = payload.tanggal_akhir}
		if (payload.filter_layanan_by) {query.filter_layanan_by = payload.filter_layanan_by; payloadCreateBlast.filter_customer.filter_layanan_by = payload.filter_layanan_by}
		if (payload.filter_kolom) {query.filter_kolom = payload.filter_kolom; payloadCreateBlast.filter_customer.filter_kolom = payload.filter_kolom}
		if (payload.idlayanan_array) {query.idlayanan_array = payload.idlayanan_array; payloadCreateBlast.filter_customer.idlayanan_array = payload.idlayanan_array}
		if (payload.iddeposit_array) {query.iddeposit_array = payload.iddeposit_array; payloadCreateBlast.filter_customer.iddeposit_array = payload.iddeposit_array}
		if (payload.outlet_array) {query.outlet_array = payload.outlet_array; payloadCreateBlast.filter_customer.outlet_array = payload.outlet_array}

		commit("setFetching", true);
		conn.get(api.listCustomer, query)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200 && status) {
					conn.setQueryString(query);
					commit("setListCustomer", data);
					commit("setPayloadCreateBlast", payloadCreateBlast)
					commit("setResponse", resulter.successResult(msg));
				} else {
					commit("setResponse", resulter.errorResult(msg));
				}
				commit("setFetching", false);
				commit("setLoadMore", false);
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setLoadMore", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},

	startBlast: async ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.startBlast, payload, conn.contentType.form);
	},
	pauseBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.pauseBlast, payload, conn.contentType.form);
	},
	cancelBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.cancelBlast, payload, conn.contentType.form);
	},
	createTemplateBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.createTemplateBlast, payload, conn.contentType.form);
	},
	updateTemplateBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.updateTemplateBlast + "/" + payload.id, payload.form, conn.contentType.form);
	},
	resendPerBlast: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.resendPerBlast, payload, conn.contentType.form);
	},
	resendPerId: ({commit}, payload) => {
		commit("setFetching", true);
		return conn.post(api.resendPerId, payload, conn.contentType.form);
	},
};